module.exports = __webpack_public_path__ + "img/facebook-profile-instruction-6.7bd6df8d.png";